import styles from './index.module.sass';

interface StatusPillProps {
    status: string;
    type: string;
}

export const getStatus = (status: Number) => {
    switch (status) {
        case 0:
            return "Pendiente";
        case 1:
            return "Aceptada";
        case 2:
            return "Rechazada";
        default:
            return "Pendiente";
    }
};

const StatusPill = (props: StatusPillProps) => {

    const getStatusColor = () => {
        switch (props.status) {
            case "Pendiente":
                return styles.Pending;
            case "Aceptada":
                return styles.Approved;
            case "Rechazada":
                return styles.Rejected;
            default:
                return styles.Default;
        }
    }

    return (
        <div className={styles.StatusPillContainer}>
            <div className={getStatusColor()}>
                <span>{props.status}</span>
            </div>
        </div>
    )


}

export default StatusPill;